<template>
  <q-dialog v-model="alert" persistent transition-show="fade" transition-hide="fade">
    <div class="hris-modal">
      <div class="hris-modal-header">
        <div>
          <h2 class="hris-modal-title">Change Password</h2>
          <p class="hris-modal-subtitle">Choose a new password for your account.</p>
        </div>
        <q-btn flat dense round @click="closeModal" aria-label="Close">
          <i class="fas fa-times"></i>
        </q-btn>
      </div>
      <q-form ref="vForm" @submit="onSubmit">
        <div class="hris-modal-body">
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input
                v-model="oldPassword"
                outlined
                dense
                color="green"
                stack-label
                label="Old Password"
                :rules="newpass"
                type="password"
              />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input
                v-model="newPassword"
                outlined
                dense
                color="green"
                stack-label
                label="New Password"
                :rules="newPassRules.concat(minimumCharacters)"
                type="password"
              />
            </div>
          </div>
          <div class="hris-form-row">
            <div class="hris-form-field" style="flex-basis: 100%;">
              <q-input
                v-model="confirmNewPassword"
                outlined
                dense
                color="green"
                stack-label
                label="Confirm New Password"
                :rules="confirmPasswordRules.concat(passwordConfirmationRule)"
                type="password"
              />
            </div>
          </div>
          <div class="text-center q-mb-sm" v-if="flag">
            <span
              class="hris-badge"
              :class="color === 'green' ? 'hris-badge-success' : 'hris-badge-danger'"
            >
              {{ message }}
            </span>
          </div>
        </div>
        <div class="hris-modal-footer">
          <q-btn unelevated class="hris-q-outline" label="Close" @click="closeModal" />
          <q-btn type="submit" unelevated class="hris-q-primary" label="Update password" />
        </div>
      </q-form>
    </div>
  </q-dialog>
</template>
<script>
import axios from 'axios';
import vueCookies from 'vue-cookies';
export default {
  name: 'ChangePassword',
  data: () => ({
    color: null,
    message: null,
    flag: false,
    alert: false,
    oldPassword: null,
    newPassword: null,
    confirmNewPassword: null,

    newpass: [v => v && v.length > 0 || 'This field is required!'],
    confirmPasswordRules: [v => !!v || 'Password is required'],
    newPassRules: [v => !!v || 'Password is required'],
  }),
  computed: {
    passwordConfirmationRule() {
      return () => this.newPassword === this.confirmNewPassword || 'Password must match';
    },
    minimumCharacters() {
      return () => this.newPassword.length >= 8 || 'Minimum of 8 characters';
    }
  },
  created() {
    this.eventHub.$on('changePassword', this.changePassword);
  },
  methods: {
    changePassword: function(payload) {
      this.alert = payload.status
    },

    closeModal: function() {
      this.alert = false;
      this.oldPassword = null;
      this.newPassword = null;
      this.confirmNewPassword = null;
    },

    onSubmit: function() {
      let formData = new FormData();
      formData.append("password", this.oldPassword);
      formData.append("newpass", this.newPassword);
      formData.append("cnewpass", this.confirmNewPassword);
      axios.create({
          baseURL: this.apiUrl,
          headers: { 'Authorization': `Bearer ${this.token}` }
        }).post('/employee/changepassword', formData)
        .then((res) => {
          this.flag = true
          this.color = 'green'
          this.message = res.data.message
          if (res.data.status == true) {
            vueCookies.remove(this.cookieKey);
            setTimeout(() => {
              location.reload();
            }, 2000);
          }
        }).catch((error) => {
          this.flag = true
          this.color = 'red'
          this.message = error.response.data.message
        });
    }
  }
}
</script>
<style>
</style>
